// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* just set some min height so it looks better after opening modal */
.adyen-checkout {
    min-height: 50vh;
}
.adyen-checkout > * {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./Client/Src/Components/Payments/Adyen/AdyenPaymentModalElement.vue"],"names":[],"mappings":";AAIA,oEAAoE;AACpE;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf","sourcesContent":["<template>\r\n    <div class=\"adyen-checkout\"></div>\r\n</template>\r\n<style>\r\n/* just set some min height so it looks better after opening modal */\r\n.adyen-checkout {\r\n    min-height: 50vh;\r\n}\r\n.adyen-checkout > * {\r\n    width: 100%;\r\n}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
